import React from "react";

import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import moment from "moment";

const useStyles = makeStyles ({
  headerTitle: {
    fontSize: "200px"
  }
});

const FormularioVisualizar = (props) => {
  const formatDate = (stringTimestamp) => {
    let data = moment(stringTimestamp, "YYYY-MM-DDTHH:mm:ss");
    return data.format("DD/MM/YYYY");
  };
  const { history, formularioVisualizar = {} } = props;
  const classes = useStyles();
  return (
    <>
      <Grid>
        <Typography
          style={{
            fontWeight: "bolder",
          }}
        >
          {formularioVisualizar.nomeFormulario}
        </Typography>
        <Typography variant="caption">
          Disponibilizado em {formatDate(formularioVisualizar.criacao)}
        </Typography>
      </Grid>
      <br />
      <Grid>
        {formularioVisualizar.campos.map((card, index) => (
          <Card 
          key={index}
          style={{ marginBottom: "30px" }}
          >
            <CardContent>
              <Typography
                style={{fontWeight: "bolder"}}
              >{"Campo " + ++index}</Typography>
              <Typography>{card.nomeCampo}</Typography>
            </CardContent>
          </Card>
        ))}
      </Grid>
    </>
  );
};

export default FormularioVisualizar;
